import { Button, Radio } from 'antd'
import axios from 'axios'
import React from 'react'
import { useHistory } from 'react-router-dom'

import { UsersList } from '@/components'
import { routes } from '@/routes'

import { useIsSystemAdmin } from '../admin.hooks'

export const OnboardingUsers: React.FC = () => {
  const history = useHistory()
  const isSystemAdmin = useIsSystemAdmin()
  const [hasOnboarding, setHasOnboarding] = React.useState(false)

  if (!isSystemAdmin) {
    return null
  }

  return (
    <>
      <div style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', padding: 16 }}>
        <Radio.Group size='large' value={hasOnboarding} onChange={(e) => setHasOnboarding(e.target.value)}>
          <Radio value={false}>未登录用户</Radio>
          <Radio value={true}>已登录用户</Radio>
        </Radio.Group>
        <Button
          type='link'
          onClick={async () => {
            const res = await axios.get('/api/users/onboarding', {
              params: {
                hasOnboarding,
                leaderOnly: false,
              },
            })
            const data = res.data
            const content = 'data:text/csv;charset=utf-8,\ufeff' + data
            const encodedUri = encodeURI(content)
            const link = document.createElement('a')
            link.setAttribute('href', encodedUri)
            link.setAttribute('download', `Tale${hasOnboarding ? '已' : '未'}登录用户.csv`)
            document.body.appendChild(link)
            link.click()
            link.remove()
          }}
        >
          下载
        </Button>
      </div>
      <UsersList
        type='allUsers'
        fetchCount={50}
        args={{ hasOnboarding }}
        pinTop={false}
        onClickUser={(u: { userId: number; email: string }) => {
          history.push(routes.users.page(u.email))
        }}
      />
    </>
  )
}
